"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pushToDataLayer;
function pushToDataLayer(data) {
  try {
    const dataLayer = window.dataLayer || [];
    return dataLayer.push(data);
  } catch (err) {
    return console.error("error in pushToDataLayer", err);
  }
}